import { SlardarContainer } from "./core/container";
import { SlardarWeb } from "./core/instances/slardar-web";
import { TtapPlugin } from "./plugins/ttap";
const Slardar = new SlardarContainer();
Slardar._inject(new SlardarWeb());
Slardar.use(new TtapPlugin());
export {
  Slardar
};

//# sourceMappingURL=singleton.js.map